import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { initI18n } from './i18n';
import './styles/globals.css';

const render = () =>
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );

// Translations are loaded first so the first paint is already localized;
// if initialization itself fails we still render rather than show a blank page.
initI18n().then(render, (error) => {
  console.error('[i18n] failed to initialize, rendering with English fallback', error);
  render();
});
